import React, { useState } from "react";
import { useCurrentUser } from "../actions/auth";
import styles from "./styles/postview.module.css";
import { getPublicImageURL } from "../_helpers/image";

const Linked_post_view = ({ content }) => {
    const {
        isLoading: loadingMe,
        isSuccess: successMe,
        data: dataMe,
    } = useCurrentUser();

    const [hoveredName, setHoveredName] = useState(false);
    const [hoveredMoreOptions, setHoveredMoreOptions] = useState(false);
    const fallback_image = "/creation_faces/user.png";
    // Don't render until user data is loaded
    if (loadingMe || !successMe) {
        return <div className={styles.loading}>Loading...</div>;
    }

    return (
        <div className={styles.feedContainer}>
            <div className={styles.post}>
                {/* Post Header */}
                <div className={styles.postHeader}>
                    <img
                        src={dataMe.avatar ? getPublicImageURL(dataMe.avatar) : fallback_image}
                        alt={`${dataMe.first_name} profile`}
                        className={styles.profilePic}
                    />
                    <div className={styles.userInfo}>
                        <button
                            className={`${styles.userName} ${hoveredName ? styles.userNameHover : ""
                                }`}
                            onMouseEnter={() => setHoveredName(true)}
                            onMouseLeave={() => setHoveredName(false)}
                        >
                            {dataMe.first_name} {dataMe.last_name}
                        </button>
                        <div className={styles.userTitle}>
                            {dataMe.selected_org?.name || ""}
                        </div>
                        <div className={styles.postTime}>
                            <span>{dataMe.status || ""}</span>
                            <div className={styles.blueDot}></div>
                            <span>🌐</span>
                        </div>
                    </div>
                    <button
                        className={`${styles.moreOptions} ${hoveredMoreOptions ? styles.moreOptionsHover : ""
                            }`}
                        onMouseEnter={() => setHoveredMoreOptions(true)}
                        onMouseLeave={() => setHoveredMoreOptions(false)}
                    >
                        ⋯
                    </button>
                </div>

                {/* Post Content */}
                <div className={styles.postContent}>
                    <div className={styles.postText}>{content?.content}</div>

                    {content?.hashtags && content?.hashtags?.length > 0 && (
                        <div className={styles.hashtagContainer}>
                            {content?.hashtags?.map((hashtag, index) => (
                                <button
                                    key={index}
                                    className={styles.hashtag}
                                    onClick={() => {
                                        /* hashtag click handler */
                                    }}
                                >
                                    {hashtag}
                                </button>
                            ))}
                        </div>
                    )}

                    {content?.image && (
                        <img
                            // src={content.image}
                            src={getPublicImageURL(content?.image)}
                            alt="Post content"
                            className={styles.postImage}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default Linked_post_view;
